import '../../components/resource_limit_counter';
import './index.scss';
import 'components/alert';
import 'components/freemium_trainer/modal';
import 'components/modals/account_limit_questions_modal';
import AjaxComponentLoader from 'utils/ajax_component_loader';
import CookieManager from 'utils/cookie_manager';
import ForumModal from 'components/modals/forum_modal';
import FreemiumLimitBottomBar from '../../components/freemium_limit_bottom_bar';
import ModalManager from 'utils/modal_manager';
import OnboardingModal from '../onboarding_modal';
import PlannerModal from 'components/modals/planner_modal';
import QuestionsReviewSuggestionModal from 'components/modals/questions_review_suggestion_modal';
import Study from 'utils/study/study';
import WeeklyActivityModal from 'components/modals/weekly_activity_modal';
import bindContinueModalEvents from 'components/modals/continue_modal';
import feedbacks from 'utils/permissions/feedbacks';
import rules from 'utils/permissions/rules';
import { EventManager } from 'utils/event_manager';
import { handleApiError } from 'utils/api_error_handler';

class Question {
  constructor($question) {
    this.$question = $question;
    this.$answerBtn = $('.js-answer-btn', this.$question);
    this.$banner = $('.q-page-content-banner');
    this.$forumBtn = $('.js-forum-btn', this.$question);
    this.questionId = $question.data('questionId');
    this.isQuestionShowPath = $question.data('question-show-path');
    this.questionParams = $question.data('questionParams');
    this.disciplineId = $question.data('disciplineId');
    this.productSlug = $question.data('productSlug');
    this.studyGuideForumAllowed = $question.data('study-guide-forum-allowed');
    this.limitWrongStreak = 8;
    this.$studentsCommentsPulse = document.querySelector(
      `.js-${this.questionId}-has-comments`
    );

    this.isFeedbackRedesignAllowed = $question.data('feedback-redesign');
    this.isAnswerTipAllowed = $question.data('show-feedback-tip');

    this.questionBeltLimitBlockExperimentIsActive =
      gon.flags.question_belt_block.visible;

    this.newQuestionLimitModalIsActive = gon.flags.modal_limitation?.active;
    this.bottomBarStudySuggestion = gon.flags.study_sugestion?.active;
    this.bannerModalLimitationIsActive =
      gon.flags.banner_modal_limitation?.active;

    this.bind();
  }

  getAlternative() {
    return $('.js-question-answer:checked', this.$question);
  }

  isResolved() {
    return this.$question.hasClass('q-question-is-correct');
  }

  isMultipleChoice() {
    return this.$question.hasClass('js-question-is-multiple-choice');
  }

  getCorrectAnswer(resolve) {
    if (this.isMultipleChoice()) {
      return resolve.right_answer;
    }

    return resolve.right_answer === 'C' ? 'Certo' : 'Errado';
  }

  async answer() {
    if (!rules.account() || !rules.confirmed_account()) {
      return;
    }

    this.$answerBtn.attr('disabled', true).attr('aria-disabled', true);

    const $alternative = this.getAlternative();
    const answer = $alternative.val();

    await this.resolveQuestion(answer);

    const data = {
      resolvedQuestions: this.resolvedTodayCounter,
      question_id: this.questionId
    };

    const chalangeQuestionAllowed =
      CookieManager.getCookie('question_challange_phase') !== 'false';

    const onboardingModalFlagOn =
      gon.flags.ansewered_correctly_won_extra_questions?.visible;

    if (
      this.resolvedTodayCounter === 9 &&
      chalangeQuestionAllowed &&
      onboardingModalFlagOn
    ) {
      this.handleQuestionChallenge();
    }

    EventManager.publish('question.answer', data);
    Study.trackWithoutCheckLimits('answers');
  }

  async resolveQuestion(answer) {
    await Thor.Question.resolve(
      {
        id: this.questionId
      },
      {
        data: {
          answer: answer,
          search_id: gon.questions_search_id,
          request_path: window.location.pathname
        }
      }
    )
      .then(data => {
        this.resolvedTodayCounter = data.used_answers;
        this.handleAnswerSuccess(answer, data);
        this.handleCheckin(data.checkin);
        this.handleFirstQuestionEvent(data.used_answers);
      })
      .catch(err => {
        this.handleAnswerError(err);
      });
  }

  handleFirstQuestionEvent(usedAnswers) {
    const isFirstQuestionToday = usedAnswers === 1;
    const isFifthQuestionToday = usedAnswers === 5;
    const isSixQuestionToday = usedAnswers === 6;

    const { active, questions } = gon.flags.experiment_free_course_base_modal;
    const canShowExperimentFreeCourseBaseModal = active && questions;

    if (
      isFirstQuestionToday &&
      gon.flags.experiment_weekly_study_goals?.active
    ) {
      setTimeout(() => {
        ModalManager.open('#js-study-goal-modal');
      }, 800);
    }

    if (
      gon.flags.experiment_paywall_on_question?.active &&
      isFirstQuestionToday
    ) {
      window?.openSubscriptionChoiceModal?.();
      return;
    }

    if (canShowExperimentFreeCourseBaseModal && isFifthQuestionToday) {
      ModalManager.open('#js-paywall-early-modal');
      return;
    }

    if (isSixQuestionToday && gon.flags.experiment_softblock_features?.active) {
      ModalManager.open('#js-question-answer-modal');
      return;
    }

    if (!isFirstQuestionToday) {
      return;
    }

    if (window.notifyExperimentBenefits) {
      window.notifyExperimentBenefits();
    }
  }

  handleCheckin(data) {
    const { active, active_weeks_count } = data;
    const isCheckinAnswer = active;

    this.checkinContent = this.$question.data('checkin-content');

    const checkinModalEnabled = isCheckinAnswer && active_weeks_count < 6;
    const isPageAllowed = !(
      this.checkinContent.index_only && this.isQuestionShowPath
    );

    if (checkinModalEnabled && isPageAllowed) {
      EventManager.publish('checkinModal.open');
      this.loadWeeklyActivityModal(active_weeks_count);
    }
  }

  async loadWeeklyActivityModal(weekNumber) {
    await AjaxComponentLoader.load({
      component: 'modals/weekly_activity_modal',
      type: 'component',
      data: {
        week_number: weekNumber,
        modal_content: this.checkinContent
      }
    }).then(html => {
      $('body').append(html);
      new WeeklyActivityModal();
    });

    ModalManager.open('#js-questions-weekly-activity-modal');
  }

  handleAnswerSuccess(answer, data) {
    const status = data.resolve.status;
    const correctAnswer = this.getCorrectAnswer(data.resolve);

    status === 'correct'
      ? this.handleCorrectAnswer()
      : this.handleWrongAnswer(answer, correctAnswer);

    if (this.resolvedTodayCounter === 4 && this.isAnswerTipAllowed) {
      this.showQuestionTip();
    }

    this.$question.parents('.js-question-item').data('status', 'resolved');
    this.$question.attr('data-answer', answer);
    this.$question.attr('data-correct-answer', correctAnswer);
    this.$banner && this.$banner.addClass('q-page-content-banner-opened');
    
    // Verificar se a flag experiment_offer_on_question está ativa
    this.handleExperimentOfferOnQuestion(data.used_answers);
    
    this.handlePlannerModal();
  }

  handleCorrectAnswer() {
    this.resetDiscipline();
    this.$question.removeClass('q-question-is-wrong');
    this.$question.addClass('q-question-is-correct');
    this.pulseStudentsComments('correct');
  }

  handleWrongAnswer(answer, correctAnswer) {
    if (this.postAllowed()) {
      this.$forumBtn.removeClass('hidden');
      this.$forumBtn.data('answer', answer);
    }

    this.pulseStudentsComments('wrong');

    if (this.isModalContinueAllowed()) {
      this.handleWrongStreak();
    }

    this.$question.addClass('q-question-is-wrong');
    this.$question.removeClass('q-question-is-correct');
    this.$question
      .find('.js-question-right-answer')
      .text(correctAnswer)
      .attr('aria-label', correctAnswer);

    this.handleExperimentTooltipQuestionBelt();
  }

  handleExperimentTooltipQuestionBelt() {
    const cookieName = `wrongAnswerTooltipViewed.${currentUser.id}`;
    const $questionBelt = $(
      `.q-question-belt[data-question-id="${this.questionId}"]`
    );

    const showTooltip = $questionBelt.data('wrong-answer-tooltip');
    const tooltipAlreadyViewed = CookieManager.getCookie(cookieName) !== null;

    if (!showTooltip || tooltipAlreadyViewed) {
      return;
    }

    const componentName = $questionBelt.data('wrong-answer-tooltip-priority');
    const $tooltip = $questionBelt.find(
      `[data-component-name="${componentName}"] [data-toggle="tooltip"]`
    );

    const oldTooltipMessage =
      $tooltip.attr('title') || $tooltip.attr('data-original-title');
    const newTooltipMessage = $tooltip.attr('wrong-answer-tooltip');

    // Change tooltip message and show tooltip
    $tooltip.attr('title', newTooltipMessage);
    $tooltip.attr('data-original-title', newTooltipMessage);
    $tooltip.addClass('wrong-answer-tooltip');
    $tooltip.tooltip().mouseover();

    // Restore tooltip message
    $tooltip.on('mouseleave', () => {
      $tooltip.attr('title', oldTooltipMessage);
      $tooltip.attr('data-original-title', oldTooltipMessage);
      $tooltip.removeClass('wrong-answer-tooltip');
    });

    // Set wrongAnswerTooltipViewed cookie
    const currentDate = new Date();
    const expirationDate = new Date(currentDate);
    expirationDate.setHours(0, 0, 0, 0);
    expirationDate.setDate(currentDate.getDate() + 1);

    CookieManager._setCookie(cookieName, true, expirationDate);
  }

  handleExperimentOfferOnQuestion(usedAnswers) {
    const experimentFlag = gon.flags?.experiment_offer_on_question;
    
    const containers = [
      $('.js-response-wrong .q-answer-feedback', this.$question),
      $('.js-response-correct .q-answer-feedback', this.$question)
    ];

    containers.forEach(($container) => {
      if ($container.length > 0) {
        $container.find('.q-answer-feedback-offer').remove();
      }
    });

    if (experimentFlag?.active && (usedAnswers === 1 || usedAnswers % 5 === 0)) {
      const linkOffer = experimentFlag.link_offer;
      const message1 = experimentFlag.message1;
      const message2 = experimentFlag.message2;

      if (linkOffer && message1 && message2) {
        const messageWithLink = `${message1} <a href="${linkOffer}" target="_blank" class="js-offer-link"><strong>${message2}</strong></a>`;
        const isCorrectAnswer = this.$question.hasClass('q-question-is-correct');

        containers.forEach(($container) => {
          if ($container.length > 0) {
            $container.find('.q-answer-feedback-item:nth-child(2)').hide();
            
            const $offerElement = $('<div class="q-answer-feedback-offer"></div>')
              .html(messageWithLink)
              .appendTo($container);

            $offerElement.find('.js-offer-link').on('click', () => {
              UserTracker.emit('event', {
                eventName: 'product awareness button clicked',
                data: {
                  'feature targeted': 'Oferta contextualizada',
                  'intervention type': isCorrectAnswer ? 'Acerto' : 'Erro',
                  'source platform': 'portal',
                  'source project': 'odin'
                }
              });
            });
          }
        });
      }
    } else {
      containers.forEach(($container) => {
        if ($container.length > 0) {
          $container.find('.q-answer-feedback-item:nth-child(2)').show();
        }
      });
    }
  }

  handleAnswerError(err) {
    const response = err.response;
    const hasJsonError = response && response.json;
    const apiErrorMessage =
      'Ops! Não foi possível resolver a questão nesse momento!';

    hasJsonError && response.status !== 401
      ? this.handleLimitRached(response)
      : handleApiError(apiErrorMessage, err?.response ?? err);
  }

  handleLimitRached(response) {
    response.json().then(data => {
      if (data.errors?.limit_reached) {
        if (this.bannerModalLimitationIsActive) {
          feedbacks.questionsLimitModal();
        } else if (this.newQuestionLimitModalIsActive) {
          feedbacks.newQuestionLimitModal();
        } else if (this.questionBeltLimitBlockExperimentIsActive) {
          feedbacks.questionBeltBlock();
        } else {
          feedbacks.resolveQuestionLimit();
        }

        if (this.isDailyReviewAllowed()) {
          this.setQuestionsReviewSuggestionListener();
        }

        const $container = $('.js-onboarding-container');

        if ($container.length) {
          $container.hide();
          CookieManager.setExpirationCookie(this.cookieName, false, 1);
        }

        if (this.bottomBarStudySuggestion) {
          const freemiumLimitBottomBar = new FreemiumLimitBottomBar();
          freemiumLimitBottomBar.load();
          freemiumLimitBottomBar.OpenBottomBarEventScroll();
        }

        this.blockQuestionBeltToUnansweredQuestion();
      }
    });
  }

  handleQuestionChallenge() {
    const answeredQuestions = CookieManager.getCookie(
      'question_challange_answered'
    ) || ['Q0'];
    const parsedAnsweredQuestions = JSON.stringify(answeredQuestions);

    AjaxComponentLoader.load({
      component: 'questions/onboarding_modal',
      type: 'page_component',
      data: {
        questions_answered_keys: parsedAnsweredQuestions
      }
    }).then(html => {
      $('body').append(html);
      new OnboardingModal();
    });
  }

  blockQuestionBeltToUnansweredQuestion() {
    const experimentQuestionBeltBlockIsActive =
      gon.flags.question_belt_block.visible;
    const experimentQuestionBeltLimitsIsActive =
      gon.flags.question_belt_limits.visible;

    const commentsTabQuestionBelt = $(
      '.js-question-item a[data-component-name="question_comments"]'
    );
    const commentedFeedbackQuestionBelt = $(
      '.js-question-item a[data-component-name="question_teacher"]'
    );
    const statisticsQuestionBelt = $(
      '.js-question-item a[data-component-name="question_statistics"]'
    );

    let questionBeltItemsThatWillBeDisabled = [...commentsTabQuestionBelt];

    if (this.questionBeltLimitBlockExperimentIsActive) {
      questionBeltItemsThatWillBeDisabled = [
        ...commentsTabQuestionBelt,
        ...commentedFeedbackQuestionBelt,
        ...statisticsQuestionBelt
      ];
    }

    if (experimentQuestionBeltLimitsIsActive) {
      return;
    }

    questionBeltItemsThatWillBeDisabled.forEach(element => {
      const $belt = $(element);

      $belt.data('limited', true);

      if (experimentQuestionBeltBlockIsActive) {
        $belt.data('disabled', true);
      } else {
        const atUnsolvedQuestion =
          $belt.parents('.js-question-item').data('status') === 'unsolved';

        if (atUnsolvedQuestion) {
          $belt.data('disabled', true);
        }
      }
    });
  }

  handlePlannerModal() {
    const { planner_modal_enabled } = gon;
    const isPlannerModalDisabled =
      localStorage.getItem('plannerModalDisabled') === 'true';
    const resolvedEnoughQuestions = this.resolvedTodayCounter === 4;

    if (
      !planner_modal_enabled ||
      isPlannerModalDisabled ||
      !resolvedEnoughQuestions
    ) {
      return;
    }

    this.loadPlannerModal();
  }

  showQuestionTip() {
    const hasCommentaries = this.$question.data('comments-count');
    const hitAnswer = this.$question.hasClass('q-question-is-correct');

    const missInfoContainer = $('.js-response-wrong', this.$question);
    const hitInfoContainer = $('.js-response-correct', this.$question);

    const hasExperimentClass = $('.q-experiment', this.$question).length > 0;

    if (hitAnswer && !hasExperimentClass) {
      return hitInfoContainer.addClass('q-show-tip-info');
    }

    const wrongAnswerFeedbackText = $('.q-answer-feedback', missInfoContainer);

    if (hasCommentaries && !hasExperimentClass) {
      wrongAnswerFeedbackText.css(
        'width',
        `${hasExperimentClass ? '100%' : '215px'}`
      );
      missInfoContainer.addClass('q-show-tip-info');
    }
  }

  pulse() {
    this.$studentsCommentsPulse.classList.toggle('hidden');
  }

  pulseStudentsComments(answer_status) {
    if (this.$studentsCommentsPulse) {
      const handleAnswer =
        this.$studentsCommentsPulse.dataset[answer_status] === 'true';

      if (handleAnswer) {
        this.pulse();
      }
    }
  }

  openQuestionsReviewSuggestionModal(self) {
    $('#js-account-limit-free-modal').off('hidden.bs.modal');

    AjaxComponentLoader.load({
      component: 'modals/questions_review_suggestion_modal',
      type: 'component',
      data: {
        product_slug: self.productSlug
      }
    }).then(html => {
      $('body').append(html);
      new QuestionsReviewSuggestionModal();
    });
  }

  isDailyReviewAllowed() {
    return gon.review_suggestion_modal_enabled;
  }

  setQuestionsReviewSuggestionListener() {
    let self = this;
    $('#js-account-limit-free-modal').on('hidden.bs.modal', () =>
      self.openQuestionsReviewSuggestionModal(self)
    );
  }

  postAllowed() {
    return (
      this.isForumAllowed() &&
      this.isForumPostAllowed() &&
      this.productSlug === 'questoes-de-concursos'
    );
  }

  isForumAllowed() {
    return window.FLAGS.access_new_course_forum;
  }

  isForumPostAllowed() {
    return this.studyGuideForumAllowed && window.FLAGS.access_new_course_forum;
  }

  loadForumModal() {
    UserTracker.emit('event', {
      eventName: 'question doubt button clicked',
      data: {
        question_id: this.questionId,
        'source platform': 'odin',
        'source project': gon.source_project
      }
    });
    $('#js-forum-modal').remove();
    AjaxComponentLoader.load({
      component: 'modals/forum_modal',
      type: 'component',
      data: {
        question_id: this.questionId,
        question_answer: this.$forumBtn.data('answer')
      }
    }).then(html => {
      $('body').append(html);
      new ForumModal('#js-forum-modal');
      ModalManager.open('#js-forum-modal');
    });
  }

  isModalContinueAllowed() {
    const allowed = window.FLAGS.modal_statistics;
    const hidden = !localStorage || localStorage.getItem('continueModalHide');

    return allowed && !hidden;
  }

  loadContinueModal() {
    AjaxComponentLoader.load({
      component: 'modals/continue_modal',
      type: 'component',
      data: {
        discipline_id: this.disciplineId,
        product_slug: this.productSlug
      }
    }).then(html => {
      $('body').append(html);
      bindContinueModalEvents();
      ModalManager.open('#js-continue-modal');
    });
  }

  loadPlannerModal() {
    AjaxComponentLoader.load({
      component: 'modals/planner_modal',
      type: 'component',
      data: {
        questions_filter: this.questionParams
      }
    })
      .then(html => {
        $('body').append(html);
        ModalManager.open('#js-planner-modal');
        new PlannerModal();
      })
      .catch(err => {
        throw new Error(err);
      });
  }

  disciplineStorageKey() {
    return `missedStreakDiscipline:${this.disciplineId}`;
  }

  wrongStreakCounter() {
    return parseInt(localStorage.getItem(this.disciplineStorageKey())) || 0;
  }

  wrongStreakIncrement() {
    localStorage.setItem(
      this.disciplineStorageKey(),
      this.wrongStreakCounter() + 1
    );
  }

  resetDiscipline() {
    localStorage.removeItem(this.disciplineStorageKey());
  }

  handleWrongStreak() {
    this.wrongStreakIncrement();

    if (this.wrongStreakCounter() >= this.limitWrongStreak) {
      this.loadContinueModal();
      this.resetDiscipline();
    }
  }

  validate() {
    const $alternative = this.getAlternative();

    if ($alternative.length && !this.isResolved()) {
      this.$answerBtn.attr('disabled', false).attr('aria-disabled', false);
    } else {
      this.$answerBtn.attr('disabled', true).attr('aria-disabled', true);
    }
  }

  discardAlternative() {
    const $discarders = $('.js-discard-alternative', this.$question);
    $discarders.on('click.discardsAlternative', e => {
      e.preventDefault();
      e.stopPropagation();

      const $discarder = $(e.currentTarget);

      $discarder.toggleClass('q-discard-alternative--discarded');

      $discarder.siblings('.js-alternative-content').toggleClass('discarded');

      $discarder.siblings('.js-question-answer').prop('checked', false);

      this.validate();
    });
  }

  recoverAlternative() {
    const $alternatives = $('.js-question-answer', this.$question);

    $alternatives.on('change.chooseAlternative', e => {
      const $alternative = $(e.currentTarget);

      $alternative.siblings('.js-alternative-content').removeClass('discarded');

      $alternative
        .siblings('.js-discard-alternative')
        .removeClass('q-discard-alternative--discarded');
    });
  }

  setFeedbackRedesign() {
    const answerFeedbacks = $('.q-inline-answer', this.$question);

    this.isFeedbackRedesignAllowed &&
      answerFeedbacks.addClass('feedback-redesign');
  }

  handleExperimentLinks() {
    $('.q-experiment', this.$question).on('click', e => {
      const $link = $(e.currentTarget);
      // const linkHref = $link.attr('href');
      // const linkText = $link.text().trim();
      const featureTargeted = $link.data('feature-targeted');
      const isCorrectAnswer = this.$question.hasClass('q-question-is-correct');
      const feedbackTypes = {
        notebook: 'Caderno',
        statistics: 'Estatísticas',
        coach: 'Resumão da Semana',
        competition: 'Concorrência',
        xray: 'Raio-X',
        practice_test: 'Simulado',
        courses: 'Cursos'
      };

      UserTracker.emit('event', {
        eventName: 'product awareness button clicked',
        data: {
          'intervention type': isCorrectAnswer ? 'Acerto' : 'Erro',
          'feature targeted': feedbackTypes[featureTargeted],
          'source platform': 'portal',
          'source project': 'odin'
        }
      });

      if (featureTargeted === 'notebook') {
        e.preventDefault();
        this.loadNotebookComponent();
      }
    });
  }

  loadNotebookComponent() {
    const $questionBelt = $(
      `.q-question-belt[data-question-id="${this.questionId}"]`
    );

    if ($questionBelt.length === 0) {
      return;
    }

    const $tab = $('[data-component-name="question_notebooks"]', $questionBelt);
    const $container = $('.js-content', $tab.attr('href'));

    if ($container.length === 0) {
      return;
    }

    const data = {
      question_id: this.questionId,
      product_id: $questionBelt.data('product-id'),
      product_key: $questionBelt.data('product-key'),
      product_slug: $questionBelt.data('product-slug'),
      already_solved: $questionBelt.data('already-solved'),
      show_path: $questionBelt.data('is-show-path')
    };

    AjaxComponentLoader.load({
      target: $container,
      component: 'questions/question_notebooks',
      type: 'page_component',
      asset_key: null,
      data: data
    })
      .then(() => {
        $tab.tab('show');

        $('html, body').animate(
          {
            scrollTop: $questionBelt.offset().top - 20
          },
          300
        );
      })
      .catch(() => {
        window.open('https://www.qconcursos.com', '_blank');
      });
  }

  bind() {
    this.$answerBtn.on('click.answer', () => this.answer());

    $('.js-question-answer', this.$question).on('change.answer', () =>
      this.validate()
    );

    this.$forumBtn.on('click', () => this.loadForumModal());

    this.setFeedbackRedesign();
    this.discardAlternative();
    this.recoverAlternative();
    this.handleExperimentLinks();
  }
}

(function ($) {
  'use strict';

  $('.js-question').each((i, el) => {
    el.question = new Question($(el));
  });
})(jQuery);
